import React from 'react'
import { Spin } from 'antd'

import type { LntSpinProps } from './types'

export const LntSpin: React.FC<LntSpinProps> = ({ children, spinning, ...props }) => {
  return (
    <Spin
      spinning={ !!spinning }
      { ...props }
    >
      { children }
    </Spin>
  )
}
